import validate from "C:/Users/zreat/Documents/Projects/ludmilaphoto/node_modules/.pnpm/nuxt@3.14.1592_sass@1.82.0_typescript@5.7.2/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "C:/Users/zreat/Documents/Projects/ludmilaphoto/node_modules/.pnpm/nuxt@3.14.1592_sass@1.82.0_typescript@5.7.2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}